import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal, props } from 'cerebral/tags'
import getStyles from './getStyles'
import getCrossStyle from './getCrossStyle'
import styles from './styles'

export default connect(
  {
    onDeselectTag: signal`selectr.onDeselectTag`,
    unFlashTag: signal`selectr.unFlashTag`,
    onDeleteTagEnter: signal`selectr.onDeleteTagEnter`,
    onDeleteTagLeave: signal`selectr.onDeleteTagLeave`,
    onBackSpace: signal`selectr.onBackSpace`,
    onLeftTag: signal`selectr.onLeftTag`,
    onRightTag: signal`selectr.onRightTag`
  },
  class Tag extends Component {
    componentWillReceiveProps(nextProps) {
      if (nextProps.flash) {
        const { unFlashTag, tagIndex, namespace } = this.props
        setTimeout(() => {
          unFlashTag({ namespace, index: tagIndex })
        }, 500)
      }
      if (nextProps.focused) {
        setTimeout(() => {
          this.ref.focus()
        }, 0)
      }
    }

    onKeyDown(e) {
      const {
        onBackSpace,
        onLeftTag,
        onRightTag,
        namespace,
        pinned
      } = this.props
      e.preventDefault()
      e.stopPropagation()
      switch (e.keyCode) {
        case 37: // left
          onLeftTag({ namespace })
          break
        case 39: // right
          onRightTag({ namespace })
          break
        case 8: // backspace
          if (!pinned) {
            onBackSpace({ namespace })
          }
          break
        default:
          return
      }
    }

    tagClicked(e) {
      const { tagClicked, namespace, label } = this.props
      if (tagClicked) {
        tagClicked({ namespace, label })
      }
    }

    render() {
      const {
        label,
        onDeselectTag,
        tagIndex,
        onDeleteTagEnter,
        onDeleteTagLeave,
        namespace,
        pinned,
        overrideStyles,
        editable
      } = this.props

      const applyStyles = getStyles(this.props)
      return (
        <div
          ref={ref => {
            this.ref = ref
          }}
          onClick={e => this.tagClicked(e)}
          tabIndex={1}
          onKeyDown={e => this.onKeyDown(e)}
          style={applyStyles}>
          {label}{' '}
          {pinned || !editable
            ? <span style={styles.pinnedCross}>&nbsp;</span>
            : <span
                onMouseEnter={e =>
                  onDeleteTagEnter({ namespace, index: tagIndex })}
                onMouseLeave={e =>
                  onDeleteTagLeave({ namespace, index: tagIndex })}
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  onDeselectTag({ namespace, index: tagIndex })
                }}
                style={getCrossStyle(overrideStyles)}>
                x
              </span>}
        </div>
      )
    }
  }
)
